import { refreshAccessToken } from "./refreshAccessToken";


export const authFetch = async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    let token=localStorage.getItem("token");    

    const response=await fetch(input,{
        ...init,
        headers:{
            ...(init?.headers || {}),
            Authorization:`Bearer ${token}`,
        }
    });

    if (response.status === 401) {
    const newToken = await refreshAccessToken();
    if (newToken) {
      return fetch(input, {
        ...init,
        headers: {
          ...(init?.headers || {}),
          Authorization: `Bearer ${newToken}`,
        },
      });
    }
  }
    return response;
}

